const vocabularyTermActionTypes =  {    
    GET_VOCABULARY_TERMS: "GET_VOCABULARY_TERMS",
    RETRIEVED_VOCABULARY_TERMS: "RETRIEVED_VOCABULARY_TERMS",
    UPDATED_VOCABULARY_TERM: "UPDATED_VOCABULARY_TERM",
    ADDED_VOCABULARY_TERM: "ADDED_VOCABULARY_TERM",
    DELETED_VOCABULARY_TERM: "DELETED_VOCABULARY_TERM",
    SET_TERM_SELECTED: "SET_TERM_SELECTED",
    CLEAR_TERMS_SELECTED: "CLEAR_TERMS_SELECTED"
};
export default vocabularyTermActionTypes;